
import { Vue, Component, Prop } from 'vue-property-decorator'
import { SolicitInfo } from '../../types/carInfo'

@Component({})
export default class ViewRegularMaintenance extends Vue {
  @Prop({ type: Object, required: true }) solicitInfo!: SolicitInfo

  get currentSolicitInfo() {
    const {
      mileage,
      maintain_expired_date,
      last_enter_workshop_date,
      next_maintain_date,
      free_ins_left_count,
      maintain_period,
      customer_type_name,
      last_follow_record
    } = this.solicitInfo

    return {
      ...this.solicitInfo,
      mileage: mileage ? `${mileage}km` : '--',
      maintain_expired_date: maintain_expired_date || '--',
      last_enter_workshop_date: last_enter_workshop_date || '--',
      next_maintain_date: next_maintain_date || '--',
      free_ins_left_count: typeof free_ins_left_count === 'number' ? `${free_ins_left_count}次` : '--',
      maintain_period: typeof maintain_period === 'number' ? `${maintain_period}月` : '--',
      customer_type_name: customer_type_name || '--',
      hasRecord: last_follow_record.recorder && last_follow_record.date,
      last_follow_record: {
        ...last_follow_record,
        type: last_follow_record.type || '--',
        remarks: last_follow_record.remarks || '--',
        next_follow_date: last_follow_record.next_follow_date || '--'
      }
    }
  }
}
